(function () {
  'use strict';

  var modal   = document.getElementById('cpm');
  if (!modal) return;

  var backdrop  = modal.querySelector('.cpm__backdrop');
  var closeBtn  = modal.querySelector('.cpm__close');
  var tableWrap = modal.querySelector('.cpm__table-wrap');
  var dots      = modal.querySelectorAll('.cpm__dot');

  function updateDots(idx) {
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
  }

  function openModal() {
    if (tableWrap) { tableWrap.scrollLeft = 0; }
    updateDots(0);
    modal.classList.add('is-visible');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
  }

  function closeModal() {
    if (!modal.classList.contains('is-open')) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      if (!modal.classList.contains('is-open')) modal.classList.remove('is-visible');
    }, 350);
  }

  if (backdrop) backdrop.addEventListener('click', closeModal);
  if (closeBtn) closeBtn.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && modal.classList.contains('is-open')) closeModal();
  });

  /* Trigger: href="#open-compare-modal" or data-open-compare-modal */
  document.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el !== document) {
      var href = el.getAttribute('href') || '';
      if (el.hasAttribute('data-open-compare-modal') || href === '#open-compare-modal') {
        e.preventDefault();
        openModal();
        return;
      }
      el = el.parentElement;
    }
  });


  /* Mobile-2: deliberate horizontal swipe detection.
     touch-action:pan-y (CSS) blocks accidental horizontal scroll; this JS fires a
     smooth column change only when the gesture is clearly intentional. */
  (function () {
    var panel = modal.querySelector('.cpm__panel');
    var wrap  = modal.querySelector('.cpm__table-wrap');
    if (!panel || !wrap) return;

    var txStart, tyStart, tsStart;

    wrap.addEventListener('touchstart', function (e) {
      if (!panel.classList.contains('cpm--mobile-2')) return;
      txStart = e.touches[0].clientX;
      tyStart = e.touches[0].clientY;
      tsStart = e.timeStamp;
    }, { passive: true });

    wrap.addEventListener('touchend', function (e) {
      if (!panel.classList.contains('cpm--mobile-2')) return;
      var dx       = e.changedTouches[0].clientX - txStart;
      var dy       = Math.abs(e.changedTouches[0].clientY - tyStart);
      var adx      = Math.abs(dx);
      var duration = Math.max(1, e.timeStamp - tsStart);
      var velocity = adx / duration;            /* px/ms */

      /* Intentional swipe: (55 px distance OR 0.55 px/ms flick) AND horizontal clearly dominates (2× vertical) */
      if ((adx < 55 && velocity < 0.55) || adx < dy * 2) return;

      var modelTh  = wrap.querySelector('.cpm__table thead th:nth-child(2)');
      var colWidth = modelTh ? modelTh.offsetWidth : 0;
      if (!colWidth) return;

      var curIdx    = Math.round(wrap.scrollLeft / colWidth);
      var targetIdx = dx < 0
        ? Math.min(2, curIdx + 1)
        : Math.max(0, curIdx - 1);

      wrap.scrollTo({ left: targetIdx * colWidth, behavior: 'smooth' });
    }, { passive: true });
  }());

  /* Btn-bar scroll sync + dot update */
  (function () {
    var wrap   = tableWrap;
    var btnBar = modal.querySelector('.cpm__btn-bar');
    var panel  = modal.querySelector('.cpm__panel');
    if (!wrap || !btnBar || !panel) return;
    wrap.addEventListener('scroll', function () {
      if (panel.classList.contains('cpm--mobile-2') && !modal.classList.contains('cpm--inline')) {
        btnBar.style.transform = 'translateX(-' + wrap.scrollLeft + 'px)';
        var modelTh = wrap.querySelector('.cpm__table thead th:nth-child(2)');
        var colW    = modelTh ? modelTh.offsetWidth : 1;
        updateDots(Math.round(wrap.scrollLeft / colW));
      } else {
        btnBar.style.transform = '';
      }
    }, { passive: true });
  }());

  /* Inline pager arrows + default to M3 (mobile 2-up) */
  (function () {
    var wrap = tableWrap;
    var prev = modal.querySelector('.cpm__pager-prev');
    var next = modal.querySelector('.cpm__pager-next');
    if (!wrap || (!prev && !next)) return;
    var panel = modal.querySelector('.cpm__panel');
    var btns = Array.prototype.slice.call(modal.querySelectorAll('.cpm__inline-btn'));
    function colW() {
      var th = wrap.querySelector('.cpm__table thead th:nth-child(2)');
      return th && th.offsetWidth ? th.offsetWidth : Math.round(wrap.clientWidth / 2);
    }
    /* Show only the buttons for the two models currently in view (mobile 2-up) */
    function syncButtons() {
      if (!btns.length) return;
      var twoUp = panel && panel.classList.contains('cpm--mobile-2') &&
                  window.matchMedia('(max-width: 767px)').matches;
      if (!twoUp) { btns.forEach(function (b) { b.classList.remove('cpm__inline-btn--hidden'); }); return; }
      var leftIdx = Math.round(wrap.scrollLeft / colW());
      btns.forEach(function (b, i) {
        b.classList.toggle('cpm__inline-btn--hidden', i < leftIdx || i > leftIdx + 1);
      });
    }
    function update() {
      var max = wrap.scrollWidth - wrap.clientWidth - 1;
      if (prev) prev.disabled = wrap.scrollLeft <= 1;
      if (next) next.disabled = wrap.scrollLeft >= max;
      syncButtons();
    }
    if (prev) prev.addEventListener('click', function () { wrap.scrollBy({ left: -colW(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { wrap.scrollBy({ left: colW(), behavior: 'smooth' }); });
    wrap.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    function init() {
      if (window.matchMedia('(max-width: 767px)').matches && modal.classList.contains('cpm--inline')) {
        var def = modal.getAttribute('data-mobile-default') || '23';
        wrap.scrollLeft = def === '12' ? 0 : wrap.scrollWidth; /* 23 → M2&M3, 12 → M1&M2 */
      }
      update();
    }
    requestAnimationFrame(function () { requestAnimationFrame(init); });
  }());

})();
